angular.module('rightPaneModule')
    .controller('StudentActivityController', [
        '$scope',
        '$state',
        'activityApi',
        'compareDay',
        'infiniteScroll',
        'reportErrors',
        'edxDateTimeService',
        'translateFilter',
         function($scope, $state, $activityApi, $compareDay, $infiniteScroll, $reportErrors, dateTimeService, translateFilter)
    {

        var computedFromDate = new Date();
        var computedToDate = new Date().setDate(computedFromDate.getDate() - 29);

        $scope.activityFeedFrom = new Date();
        $scope.activityFeedTo = new Date();

        $scope.activityFeedFrom = computedFromDate;
        $scope.activityFeedTo = computedToDate;

        $scope.fromDateDay = dateTimeService.dayOfWeekOrToday(computedFromDate);
        $scope.toDateDay = dateTimeService.dayOfWeekOrToday(computedToDate);

        var NO_EVENTS_MESSAGE = translateFilter('errors.noEventsStudent');
        var NO_MORE_EVENTS_MESSAGE = translateFilter('errors.noMoreEventsStudent');

        $scope.enableInfiniteScroll = true;
        $scope.showStudentNames = false; // At the student level no need to display names on the card.

        var updateNoEventsMessage = function () {
            if (!$scope.events.length && !$scope.busy) {
                $scope.noDataMessage = NO_EVENTS_MESSAGE;
            } else if ($scope.events.length && $scope.endOfPage) {
                $scope.noDataMessage = NO_MORE_EVENTS_MESSAGE;
            } else {
                $scope.noDataMessage = undefined;
            }
        };

        var updateStudentActivities = function() {
            $scope.activityError = null;
            var nextPage = $infiniteScroll.getNextPage();
            var districtId = $state.params.districtId;
            var studentId = $scope.item.id;
            $activityApi.getStudentActivities(districtId, studentId, undefined, undefined, undefined, false, nextPage).then(function(data) {
                $infiniteScroll.handlePageResponse($scope, data);
                $scope.events = ($scope.events || []).concat(data.activities);
                updateNoEventsMessage();
            }, function(error) {
                $scope.activityError = $reportErrors.getErrorMessage(error);
            });
        };

        var initializeData = function(e, item) {
            $scope.item = item;
            // IN-618 include today
            $compareDay.resetGroupedByDate(true);

            updateStudentActivities();
        };

        $scope.$on('itemReady', initializeData);
        $infiniteScroll.init($scope, updateStudentActivities);
    }]);
